$(document).ready(function(){

$('.navbar-toggle').on('click', function(){
	$(this).toggleClass('open');
	$('nav.nav-global').toggleClass('hidden');
	$('body').toggleClass('freeze');
})

$('.color-picker svg').on('click', function(){
	$(this).addClass('active').siblings('svg').removeClass('active');
})
$('.sizes-picker span').on('click', function(){
	$(this).addClass('active').siblings('span').removeClass('active');
})
$('.manual-overlay div.close, .open-manual').on('click', function(){
	$('.manual-overlay').toggleClass('hidden');
})





//
// GALLERIES
//

	$( '.slick-slider-module-gallery' ).each(function() {
		var sliderId = $(this).attr('data-id');
		console.log(sliderId);
    	$(this).slick({
		//fade: true,
		arrows: true,
		mobileFirst: true,
		variableWidth: false,
		arrows: true,
		prevArrow:$('.previ_slider[data-id="'+sliderId+'"]'),
  		nextArrow:$('.nexti_slider[data-id="'+sliderId+'"]'),
  // 		nextArrow: $(this).parents('module__gallery-slider').find('.previ_slider'),
		// prevArrow: $(this).parents('module__gallery-slider').find('.nexti_slider'),
  		infinite: false,
	});
  });


	$('.slick-slider-module-gallery').on('afterChange', function(event, slick, currentSlide){
		var sliderId = $(this).attr('data-id');
	  console.log(currentSlide + 1);
	  $('div.counter[data-id="'+sliderId+'"] span.current-image-index').html(currentSlide + 1);
	  // left
	});


$('.slick-slider-cards-expanded').each(function( i ) {
	var sliderId = $(this).attr('data-id');
	$(this).slick({
		//fade: true,
		mobileFirst: true,
		//slidesToShow: 1.5,
		//centerMode: true,
		variableWidth: true,
		prevArrow:$('.previ_slider[data-id="'+sliderId+'"]'),
  		nextArrow:$('.nexti_slider[data-id="'+sliderId+'"]'),
  		infinite: false,
  		responsive: [
	    {
	      breakpoint: 600,
	      settings: {
	        arrows: false,
	        //centerMode: true,
	        //centerPadding: '40px',
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 900,
	      settings: {
	        arrows: false,
	        //centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 3,
	        slidesToScroll: 3
	      }
	    },
	    {
	      breakpoint: 1200,
	      settings: {
	        arrows: false,
	        //centerMode: true,
	        //centerPadding: '80px',
	        slidesToShow: 3,
	        slidesToScroll: 3
	      }
	    }
	  ]
	});
	  });

	// 	$('.slick-slider-cards-collapsed').slick({
	// 	//fade: true,
	// 	mobileFirst: true,
	// 	//slidesToShow: 1.5,
	// 	//centerMode: true,
	// 	rows: 2,
	// 	variableWidth: true,
	// 	prevArrow:$(".previ_slider"),
 //  		nextArrow:$(".nexti_slider"),
 //  		infinite: false,
 //  		responsive: [
	//     {
	//       breakpoint: 600,
	//       settings: {
	//         arrows: false,
	//         //centerMode: true,
	//         //centerPadding: '40px',
	//         slidesToShow: 2,
	//         slidesToScroll: 2
	//       }
	//     },
	//     {
	//       breakpoint: 900,
	//       settings: {
	//         arrows: false,
	//         //centerMode: true,
	//         //centerPadding: '0px',
	//         slidesToShow: 3,
	//         slidesToScroll: 3
	//       }
	//     },
	//     {
	//       breakpoint: 1200,
	//       settings: {
	//         arrows: false,
	//         //centerMode: true,
	//         //centerPadding: '80px',
	//         slidesToShow: 3,
	//         slidesToScroll: 3
	//       }
	//     }
	//   ]
	// });

	
});